import { Button } from '@nextui-org/react-latest'
import Image from 'next/image'
import { useTranslation } from 'react-i18next'
import { useAuth } from '@contexts/Auth'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules'
import 'swiper/css'

type Props = {
  handleBecomeCreator: () => void
}

const TrustedStudents = ({ handleBecomeCreator }: Props) => {
  const companies = [
    { name: 'Adobe', logo: '/static/images/logos/Adobe.png' },
    { name: 'Airbnb', logo: '/static/images/logos/Airbnd.png' },
    { name: 'Airtable', logo: '/static/images/logos/Airtable.png' },
    { name: 'Amazon', logo: '/static/images/logos/Amazon.png' },
    { name: 'Apple', logo: '/static/images/logos/Apple.png' },
    { name: 'Asana', logo: '/static/images/logos/Asana.png' },
    { name: 'Atlassian', logo: '/static/images/logos/Atlassian.png' },
    { name: 'DocuSign', logo: '/static/images/logos/Docu-Sign.png' },
    { name: 'Dribbble', logo: '/static/images/logos/Dribble.png' },
    { name: 'Figma', logo: '/static/images/logos/Figma.png' },
    { name: 'GitHub', logo: '/static/images/logos/Github.png' },
    { name: 'Google', logo: '/static/images/logos/Google.png' },
    { name: 'Grammarly', logo: '/static/images/logos/Grammerly.png' },
    { name: 'HubSpot', logo: '/static/images/logos/Hubspot.png' },
    { name: 'Klarna', logo: '/static/images/logos/Klarna.png' },
    { name: 'MailChimp', logo: '/static/images/logos/Mail-Chimp.png' },
    { name: 'Microsoft', logo: '/static/images/logos/Microsoft.png' },
    { name: 'Monday', logo: '/static/images/logos/Monday.png' },
    { name: 'Netflix', logo: '/static/images/logos/Netflix.png' },
    { name: 'OpenAI', logo: '/static/images/logos/OpenAi.png' },
    { name: 'Pinterest', logo: '/static/images/logos/Pinterest.png' },
    { name: 'Revolut', logo: '/static/images/logos/Revolut.png' },
    { name: 'Slack', logo: '/static/images/logos/Slack.png' },
    { name: 'Stripe', logo: '/static/images/logos/Stripe.png' },
    { name: 'Tesla', logo: '/static/images/logos/Tesla.png' },
    { name: 'Tinder', logo: '/static/images/logos/Tinder.png' },
    { name: 'Uber', logo: '/static/images/logos/Uber.png' },
    { name: 'Visa', logo: '/static/images/logos/Visa.png' },
  ]

  const { t } = useTranslation('homeLanding/trustedstudents')
  const { user } = useAuth()

  return (
    <div className="w-full py-24 text-center">
      <h2 className="text-3xl max-w-desktop mx-auto px-4 md:text-5xl font-bold text-uguPurple">
        {t('titleLine1')}
        <br />
        {t('titleLine2')}
      </h2>

      <SwiperContainer>
        <Swiper
          modules={[Autoplay]}
          spaceBetween={0}
          slidesPerView="auto"
          loop={true}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          speed={3000}
          freeMode={true}
          allowTouchMove={false}
          className="trusted-companies-swiper"
        >
          {[...companies, ...companies].map((company, index) => (
            <SwiperSlide key={`${company.name}-${index}`} className="!w-auto">
              <LogoItem>
                <Image
                  src={company.logo}
                  alt={company.name}
                  width={160}
                  height={60}
                  unoptimized={true}
                  className="logo-image"
                />
              </LogoItem>
            </SwiperSlide>
          ))}
        </Swiper>
      </SwiperContainer>

      <Button
        radius="full"
        className="font-medium py-7 px-8 sm:mx-auto mx-4"
        size="lg"
        color="primary"
        onPress={handleBecomeCreator}
      >
        {t(user?.isAuthor ? 'Dasboard' : 'button')}
      </Button>
    </div>
  )
}

export default TrustedStudents

import styled from '@emotion/styled'

const SwiperContainer = styled.div`
  width: 100%;
  margin: 56px 0;
  overflow: hidden;
  position: relative;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    width: 100px;
    height: 100%;
    z-index: 2;
  }

  &::before {
    left: 0;
    background: linear-gradient(to right, white, transparent);
  }

  &::after {
    right: 0;
    background: linear-gradient(to left, white, transparent);
  }

  .trusted-companies-swiper {
    overflow: visible;
  }

  .swiper-wrapper {
    transition-timing-function: linear;
  }
`

const LogoItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 180px;
  height: 60px;
  margin-right: 1.75rem;

  .logo-image {
    width: auto;
    height: auto;
    display: block;
    max-width: 160px;
    max-height: 60px;
    object-fit: contain;
  }
`
